export default __webpack_public_path__ + "static/media/cif-sr.c4807864.svg";